import { render, staticRenderFns } from "./Approvers.vue?vue&type=template&id=0e8b5f5a"
import script from "./Approvers.vue?vue&type=script&lang=js"
export * from "./Approvers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports